import { render, staticRenderFns } from "./qna.vue?vue&type=template&id=38ac7bf7&scoped=true&"
import script from "./qna.vue?vue&type=script&lang=js&"
export * from "./qna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ac7bf7",
  null
  
)

export default component.exports